<div class="profile-photo">
    <button
        type="button"
        class="profile-photo__avatar"
        [attr.aria-label]="(photoUrl() ? 'profile.photo.modify' : 'profile.photo.add') | transloco"
        (click)="openManager()"
    >
        @if (photoUrl(); as src) {
            <img
                alt=""
                class="profile-photo__image"
                [src]="src"
            />
        } @else {
            <span class="profile-photo__initials">{{ [firstName(), lastName()] | nameInitials }}</span>
        }

        <span class="profile-photo__badge">
            <eb-icon
                icon="ui/action/symbols/pen"
                width="14"
            />
        </span>
    </button>
</div>
